import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-scroll";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, FreeMode, Mousewheel } from "swiper/modules";
import "swiper/css/autoplay";
import "swiper/css/mousewheel";
import Footer from "../component/Footer.js";
import { RiArrowDownSFill } from "react-icons/ri";
import { StrokedText } from "stroked-text";
import { RxCross2 } from "react-icons/rx";
import { AuthContext, useSupabase } from "../App";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const strengths = [
  {
    title: "One Stop Service",
    description: "A policy can be issued and used immediately.",
    icon: "/strength1.png",
  },
  {
    title: "A Strong Alliances",
    description:
      "Received cooperation from relevant government and private agencies in Thailand.",
    icon: "/strength2.png",
  },
  {
    title: "Experience",
    description: "Over 72 years of experience in insurance sectors.",
    icon: "/strength3.png",
  },
  {
    title: "Various Coverage",
    description: "Covered in a variety of insurances.",
    icon: "/strength4.png",
  },
  {
    title: "After-Sales Service",
    description: "Excellent after-sales service.",
    icon: "/strength5.png",
  },
];

const reviews = [
  {
    name: "TANYATON SAENG.",
    rating: 5,
    review:
      "Good service, supports various information well and gives very good advice.",
  },
  {
    name: "WARIT PECH.",
    rating: 4,
    review: "Good price and service.",
  },
  {
    name: "SUPHAK NEE.",
    rating: 4,
    review: "Supports the information very well, but the price is a bit high.",
  },
  {
    name: "PEERAWITCH CHA.",
    rating: 5,
    review: "Staff supports the information very well when I got an accident.",
  },
  {
    name: "PEERAWAT K.",
    rating: 3,
    review: "Website can be improved further.",
  },
];

// const FAQItem = ({ question, answer }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <div className="mb-2">
//       <button
//         onClick={() => setOpen(!open)}
//         className="w-full flex justify-between items-center p-4 bg-gray-200 border border-gray-400 rounded-md shadow-md"
//       >
//         <div className="flex items-center gap-2">
//           <FaPlay className="text-red-500" />
//           <span className="text-gray-700 font-semibold">{question}</span>
//         </div>
//         {open ? <FaChevronUp /> : <FaChevronDown />}
//       </button>
//       {open && (
//         <div className="p-4 bg-red-600 text-white rounded-md mt-2 shadow-md">
//           {answer}
//         </div>
//       )}
//     </div>
//   );
// };

const Home = () => {
  const [Language, setLanguage] = useState({ value: "EN", label: "EN" });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupLogin, setPopupLogin] = useState(false);
  const [popupSignup, setPopupSignup] = useState(false);
  const [popupForgot, setPopupForgot] = useState(false);
  const [pkg, setPkg] = useState("");
  const [isRemember, setIsRemember] = useState(false);
  const supabase = useSupabase();
  const navigate = useNavigate();
  const { session, apiUrl } = useContext(AuthContext);
  const averageRating =
    reviews.reduce((sum, item) => sum + item.rating, 0) / reviews.length;
  const [email, setEmail] = useState("");
  useEffect(() => {
    const element = document.getElementById("my-target-id");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  useEffect(() => {
    supabase.auth.onAuthStateChange(async (event) => {
      if (event == "PASSWORD_RECOVERY") {
        const newPassword = prompt(
          "What would you like your new password to be?"
        );
        const { data, error } = await supabase.auth.updateUser({
          password: newPassword,
        });
        if (data) alert("Password updated successfully!");
        if (error) alert("There was an error updating your password.");
      }
    });
  }, []);
  // useEffect(() => {
  //   if (popupSignup) {
  //     document.body.style.overflow = "hidden"; // ปิด scrollbar ของ body
  //   } else {
  //     document.body.style.overflow = "auto"; // เปิดกลับ
  //   }

  //   return () => {
  //     document.body.style.overflow = "auto"; // Cleanup เมื่อ component unmount
  //   };
  // }, [popupSignup]);
  const handleButtonClick = (pkg) => {
    setPkg(pkg);
    setIsPopupOpen(true);
  };

  const handleRememberChange = () => {
    setIsRemember(!isRemember);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleLogin = (event) => {
    event.preventDefault();
    console.log(event.target[0].value);
    console.log(event.target[1].value);
    const { data, error } = supabase.auth
      .signInWithPassword({
        email: event.target[0].value,
        password: event.target[1].value,
      })
      .then((res) => {
        console.log(res);
        console.log(data);
        console.log(error);
        console.log(res?.data?.user.id);
        if (res?.error === null) {
          axios
            .post(`${apiUrl}/adddata`, { user_id: res?.data?.user.id })
            .then((res) => {
              if (res.status === 200) {
                alert("Login success");
                setPopupLogin(false);
              }
            });
        }
        if (res?.error?.message === "Invalid login credentials") {
          alert("Email or password does not correct.");
        }
      })
      .catch((err) => {
        alert("There is an error. Please try again.");
        console.error(err);
      });
  };
  const handleSignup = (event) => {
    event.preventDefault();
    console.log(event.target[0].value);
    console.log(event.target[1].value);
    console.log(event.target[2].value);
    if (
      event.target[0].value.length == 0 ||
      event.target[1].value.length == 0 ||
      event.target[2].value.length == 0
    ) {
      return alert("Please fill in all the fields.");
    }
    if (event.target[1].value < 6) {
      return alert("Password should be at least 6 characters.");
    }
    if (event.target[1].value !== event.target[2].value) {
      return alert("Password and comfrim Password does not match.");
    }
    axios
      .post(`${apiUrl}/register`, {
        email: event.target[0].value,
        password: event.target[1].value,
      })
      .then((res) => {
        if (res.data.error === "Email already registered") {
          console.log(res.data.user);
          if (res.data?.user.email_confirmed_at === "") {
            alert("Email already registered. Please login.");
            setPopupSignup(false);
            return;
          } else {
            alert(
              "You have already registered. Please check your email to confirm."
            );
            setPopupSignup(false);
            return;
          }
        }
        console.log(res);
        setPopupSignup(false);
        alert("Register success. Please check your email to verify.");
      })
      .catch((err) => {
        alert("There is an error. Please try again.");
        console.log(err);
        console.error(err);
      });
  };

  const updateSlideStyles = (swiper) => {
    swiper.slides.forEach((slide, index) => {
      if (index === swiper.activeIndex) {
        slide.style.transform = "scale(1)";
        slide.style.opacity = "1";
      } else {
        slide.style.transform = "scale(0.8)";
        slide.style.opacity = "0.9";
      }
    });
  };
  const openPopupLogin = () => {
    if (session) {
      return navigate("/profile");
    }
    setPopupSignup(false);
    setPopupForgot(false);
    setPopupLogin(true);
  };
  const closePopupLogin = () => {
    setPopupLogin(false);
  };
  const openPopupSignup = () => {
    setPopupLogin(false);
    setPopupSignup(true);
  };
  const openPopupForgot = () => {
    setPopupLogin(false);
    setPopupForgot(true);
  };
  const closePopupForgot = async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      alert("Please enter a valid email address.");
    } else {
      const { data, error } = await supabase.auth.resetPasswordForEmail(email);
      if (error) {
        alert("There is an error. Please try again.");
        console.error(error);
      } else {
        alert("Check your email to reset your password.");
        setPopupForgot(false);
      }
    }
  };

  return (
    <div id="home" className="w-full h-auto overflow-x-hidden scrollbar-none">
      <div className="absolute top-0 left-0 z-20 w-full h-[7vw]">
        <div className="flex w-full h-full  justify-around items-center">
          <button onClick={openPopupLogin} className="flex  w-6 left-0" to="/">
            <svg
              viewBox="0 0 24 23"
              fill="white"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 21.5455C0 17.9305 2.9305 15 6.54545 15H17.4545C21.0695 15 24 17.9305 24 21.5455C24 22.3488 23.3488 23 22.5455 23H1.45455C0.651222 23 0 22.3488 0 21.5455Z"
                fill="#EAEAEA"
              />
              <path
                d="M19 6.5C19 10.0899 16.0899 13 12.5 13C8.91015 13 6 10.0899 6 6.5C6 2.91015 8.91015 0 12.5 0C16.0899 0 19 2.91015 19 6.5Z"
                fill="#EAEAEA"
              />
            </svg>
          </button>
          <nav className="flex items-center ">
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="home"
            >
              HOME
            </Link>
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="product"
            >
              PRODUCTS
            </Link>
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="strength"
            >
              STRENGTH
            </Link>
            <img src="/logo.png" className="w-auto h-[7vw] px-6" alt="" />
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="review"
            >
              REVIEWS
            </Link>
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="/"
            >
              FAQ
            </Link>
            <Link
              className="flex items-start justify-start m-3 text-white text-base leading-2 md:text-md md:p-2 lg:text-lg lg:leading-4  font-oswald bg-clip-text cursor-pointer"
              to="/"
            >
              SERVICE
            </Link>
          </nav>
          <div className="flex min-w-[60px] justify-center items-center">
            <Select
              options={[
                {
                  value: "EN",
                  label: "EN",
                },
              ]}
              className="w-full  rounded-md text-center text-black text-base "
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "transparent",
                  border: "1px solid white",
                  color: "white",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "white",
                }),
                menu: (provided) => ({
                  ...provided,
                  backgroundColor: "white",
                }),
                indicatorSeparator: () => ({
                  display: "none",
                }),
                dropdownIndicator: (provided) => ({
                  ...provided,
                  padding: "0px",
                  paddingRight: "4px",
                }),
                option: (provided) => ({
                  ...provided,
                  textTransform: "none",
                }),
              }}
              value={Language}
              onChange={(option) => setLanguage(option)}
              components={{
                DropdownIndicator: () => <RiArrowDownSFill />,
              }}
              isSearchable={false}
            />
          </div>
        </div>
      </div>
      <div className="absolute top-0 z-10 w-full h-[20vw] bg-gradient-to-b from-[rgba(0,0,0,0.7)] to-[rgba(102,102,102,0)] bg-opacity-10" />
      <div className="absolute top-[28.5vw] z-10 w-full h-[6.7vw] bg-gradient-to-b from-[#66666600] to-[#F6F6F6]  pointer-events-none" />
      <div className="w-full bg-[#0F2C59]">
        <Swiper
          direction="vertical"
          slidesPerView={1}
          pagination={{
            clickable: true,
            el: ".custom-swiper-pagination",
            type: "bullets",
          }}
          observer={true}
          observeParents={true}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay, Pagination]}
          className="w-[66vw] h-[35vw] z-10"
        >
          <SwiperSlide>
            <img src="/banner1.png" className=" w-full h-[35vw]" alt="" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/banner2.png" className="w-full h-[35vw]" alt="" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/banner3.png" className="w-full h-[35vw]" alt="" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/banner4.png" className="w-full h-[35vw]" alt="" />
          </SwiperSlide>
          <SwiperSlide>
            <img src="/banner5.png" className="w-full h-[35vw]" alt="" />
          </SwiperSlide>
        </Swiper>
        <div className="custom-swiper-pagination absolute !top-[29.5vw] !left-[17vw] w-fit bg-gray-300/70 px-[0.3vw] py-[0.3vw] rounded-[8px]" />
      </div>

      <Swiper
        style={{
          "--swiper-pagination-color": "rgba(255, 255, 255, 1)",
          "--swiper-pagination-bullet-inactive-color": "rgba(175, 175, 175, 1)",
          "--swiper-pagination-bullet-inactive-opacity": "1",
          "--swiper-pagination-bullet-size": "0.75vw",
        }}
        slidesPerView={1.8}
        centeredSlides={true}
        spaceBetween={10}
        pagination={{
          clickable: false,
          type: "bullets",
        }}
        loop={true}
        observer={true}
        observeParents={true}
        onSwiper={(swiper) => updateSlideStyles(swiper)}
        onSlideChange={(swiper) => updateSlideStyles(swiper)}
        onProgress={(swiper) => updateSlideStyles(swiper)}
        modules={[Pagination, Autoplay]}
        className="!absolute top-[30vw] w-full !z-50 h-[24vw] custom-swiper2"
      >
        <SwiperSlide>
          <div className="flex justify-center items-center custom-swiper3">
            <img src="/banner2-1.png" className="w-auto h-[22.5vw]" alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="flex justify-center items-center custom-swiper3">
            <img src="/banner2-1.png" className="w-auto h-[22.5vw]" alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="flex justify-center items-center custom-swiper3">
            <img src="/banner2-1.png" className="w-auto h-[22.5vw]" alt="" />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="flex justify-center items-center custom-swiper3">
            <img src="/banner2-1.png" className="w-auto h-[22.5vw]" alt="" />
          </div>
        </SwiperSlide>
      </Swiper>
      <div className="h-[26vw]" />
      <div className="flex flex-col items-center space-y-10 font-poppins mb-20">
        <div className="text-center p-6 w-full ">
          <h2 className="text-[32px] font-normal text-black leading-[140%]">
            Report an accident or need assistance or check claim status.
          </h2>
          <p className="text-2xl text-black leading-[140%]">
            Lapor kemalangan atau perlukan bantuan atau semak status tuntutan.
          </p>
          <p className="text-2xl text-black leading-[160%]">
            报告事故或需要帮助或查询理赔状态
          </p>
          <p className="text-base text-red-500 leading-[157%]">
            Click below to start your claim process now !
          </p>
          <a
            href="https://wa.me/message/SM6EHEQA4CUSP1"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center justify-center bg-[#45C655] text-white text-2xl font-medium px-6 py-2 rounded-xl hover:bg-green-600 transition"
            style={{
              boxShadow:
                "inset -2px -2px 4px rgba(0, 0, 0, 0.7),inset 2px 2px 4px rgba(255, 255, 255, 0.7)",
              filter: "drop-shadow(0px 4px 6.9px rgba(0, 0, 0, 0.25))",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              className="w-8 h-8 mr-2"
            />
            Start Your Claim
          </a>
        </div>
      </div>

      <div>
        <img src="/background.png" className="absolute w-full h-auto " alt="" />
        <div
          id="product"
          className="w-full h-auto flex flex-row justify-center p-20 gap-6 font-poppins"
        >
          <div className="basis-[22.5%] w-full pt-10">
            <div
              className="relative w-full rounded-2xl top-0 h-[26vw] bg-[#DEDEE0]"
              style={{
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <img
                src="/silver.png"
                alt=""
                className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 z-20"
              />
              <div
                className="w-full h-1/2 absolute top-0 z-10 rounded-t-2xl"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(251, 251, 251, 0.5) 50%, rgba(222, 222, 224,1) 100%)",
                }}
              />
              <img
                src="/silver_bg.png"
                alt=""
                className="w-full h-1/2 absolute top-0 z-0 rounded-t-2xl"
              />
              <div className="relative pt-10 z-20">
                <StrokedText
                  className="relative font-bold text-xl left-1/2 -translate-x-1/2"
                  fill="#474747"
                  stroke="#DEDEE0"
                  strokeWidth={2}
                >
                  Silver Package
                </StrokedText>
                <StrokedText
                  className="relative font-medium text-[8px] py-2 tracking-widest left-1/2 -translate-x-1/2"
                  fill="#474747"
                  stroke="#DEDEE0"
                  strokeWidth={1}
                >
                  Include Compulsory + TA
                </StrokedText>
              </div>
              <div className="relative text-[#7B7B7B] px-10 text-sm font-normal pt-4 z-20">
                <ul className="list-disc pl-4 leading-8">
                  <li>Compulsory car insurance</li>
                  <li>TM.2 Thai Immigration Form</li>
                  <li>TM.3 Thai Immigration Form</li>
                  <li>Roadside Service</li>
                  <li>Free Travel Insurance for Driver (7 days)</li>
                </ul>
              </div>
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-center text-[#7B7B7B] tracking-widest">
                starting at
              </div>
              <button
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2  bg-[#F2F2F2] rounded-full px-8 py-2 text-[#474747] text-base font-bold"
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
                onClick={() => handleButtonClick("silver")}
              >
                RM30.00
              </button>
            </div>
          </div>

          <div className="basis-[24%] w-full">
            <div
              className="relative w-full rounded-2xl top-0 h-[31vw] bg-[#C8A53D]"
              style={{
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <img
                src="/gold.png"
                alt=""
                className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 z-20"
              />
              <div
                className="w-full h-1/2 absolute top-0 z-10 rounded-t-2xl"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(138, 111, 23, 0.2) 0%, rgba(138, 111, 23, 0.5) 50%, rgba(200, 165, 61,1) 100%)",
                }}
              />
              <img
                src="/gold_bg.png"
                alt=""
                className="w-full h-1/2 absolute top-0 z-0 rounded-t-2xl"
              />
              <div className="relative z-20 pt-14">
                <StrokedText
                  className="relative font-bold text-xl left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#C8A53D"
                  strokeWidth={2}
                >
                  Gold Package
                </StrokedText>
                <StrokedText
                  className="relative font-medium text-[8px] py-2 tracking-widest left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#C8A53D"
                  strokeWidth={1}
                >
                  Include Compulsory + TA + Voluntary Insurance 3+
                </StrokedText>
              </div>
              <div className="relative z-20 text-[#FFFFFF] px-10 text-sm font-normal pt-4 ">
                <ul className="list-disc pl-4 leading-8">
                  <li>Compulsory car insurance</li>
                  <li>
                    Voluntary insurance
                    <span className="block text-black">
                      ( Coverage your own car )
                    </span>
                  </li>
                  <li>TM.2 Thai Immigration Form</li>
                  <li>TM.3 Thai Immigration Form</li>
                  <li>Roadside Service</li>
                  <li>Free Travel Insurance for Driver (7 days)</li>
                </ul>
              </div>
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-center text-[#FFFFFF] tracking-widest">
                starting at
              </div>
              <NavLink
                to="/info?pkg=gold"
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2  bg-[#F2F2F2] rounded-full px-8 py-2 text-[#C8A53D] text-base font-bold"
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
              >
                RM195.00
              </NavLink>
            </div>
          </div>

          <div className="basis-[22.5%] w-full pt-10">
            <div
              className="relative w-full rounded-2xl top-0 h-[26vw] bg-[#520C0D]"
              style={{
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <img
                src="/ruby.png"
                alt=""
                className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 z-20"
              />
              <div
                className="w-full h-1/2 absolute top-0 z-10 rounded-t-2xl"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(82, 12, 13, 0.2) 0%, rgba(82, 12, 13, 0.5) 50%, rgba(82, 12, 13,1) 100%)",
                }}
              />
              <img
                src="/ruby_bg.png"
                alt=""
                className="w-full h-1/2 absolute top-0 z-0 rounded-t-2xl"
              />
              <div className="relative z-20 pt-10">
                <StrokedText
                  className="relative font-bold text-xl left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#940709"
                  strokeWidth={2}
                >
                  Ruby Package
                </StrokedText>
                <StrokedText
                  className="relative font-medium text-[8px] py-2 tracking-widest left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#940709"
                  strokeWidth={1}
                >
                  Include Compulsory + TA + Voluntary Insurance
                </StrokedText>
              </div>
              <div className="relative z-20 pb-9 text-[#FFFFFF] px-10 text-sm font-normal pt-4 ">
                <ul className="list-disc pl-4 leading-8">
                  <li>Compulsory car insurance</li>
                  <li>Voluntary insurance</li>
                  <li>TM.2 Thai Immigration Form</li>
                  <li>TM.3 Thai Immigration Form</li>
                  <li>Roadside Service</li>
                  <li>Free Travel Insurance for Driver (7 days)</li>
                </ul>
              </div>
              <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[9px] font-bold text-center text-[#FFFFFF] tracking-widest">
                starting at
              </div>
              <button
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2  bg-[#F2F2F2] rounded-full px-8 py-2 text-[#520C0D] text-base font-bold"
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
                onClick={() => handleButtonClick("ruby")}
              >
                RM120.00
              </button>
            </div>
          </div>

          <div className="basis-[22.5%] w-full pt-10">
            <div
              className="relative w-full rounded-2xl top-0 h-[26vw] bg-[#17519E]"
              style={{
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div
                className="w-full h-1/2 absolute top-0 z-10 rounded-t-2xl"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(49, 120, 214, 0.2) 0%, rgba(49, 120, 214, 0.5) 50%, rgba(23, 81, 158,1) 100%)",
                }}
              />
              <img
                src="/ta_bg.png"
                alt=""
                className="w-full h-1/2 absolute top-0 z-0 rounded-t-2xl"
              />
              <div className="relative z-20 pt-10 text-[#F6F6F6] text-center">
                <StrokedText
                  className="relative font-bold text-xl left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#17519E"
                  strokeWidth={2}
                >
                  TA
                </StrokedText>
                <StrokedText
                  className="relative font-medium text-[8px] py-2 tracking-widest left-1/2 -translate-x-1/2"
                  fill="#F6F6F6"
                  stroke="#17519E"
                  strokeWidth={1}
                >
                  Thailand Travel Insurance
                </StrokedText>
                <div className="flex items-center justify-center mt-10  w-full h-full">
                  <img src="/ta_pic.png" alt="" />
                </div>
              </div>
              <NavLink
                to="/info?pkg=ta"
                className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2  bg-[#F2F2F2] rounded-full px-8 py-2 text-[#17519E] text-base font-bold"
                style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
              >
                RM67.00
              </NavLink>
            </div>
          </div>
        </div>
        <div className="relative h-screen mt-16 py-16 px-6 text-left flex flex-row items-center md:items-start font-poppins">
          <div className="absolute inset-0 text-[#0F2C59] text-[210px] leading-[110%] font-bold opacity-60 flex justify-center items-center">
            <span className="absolute left-[10%]">
              HOW
              <br />
              TO
              <br /> PURCHASE
            </span>
          </div>
          <div className="relative w-full flex justify-center left-[12%] top-[22%]">
            <div className="w-[85%] h-[50vh] bg-black rounded-lg flex justify-center items-center ">
              <span className="text-white">Video Placeholder</span>
            </div>
          </div>
          <div className="relative w-full  mt-6 md:mt-0 left-[12%] top-[22%]">
            <h3 className="text-3xl font-bold text-gray-800">
              5-Step To Happy In <br />
              Thailand
            </h3>
            <p className="text-[#6D6D6D] text-xl mt-4 ml-8 flex flex-row">
              Step 1:
              <a className="pl-1 w-[40%]"> Select the plan that you want</a>
            </p>
            <p className="text-[#6D6D6D] text-xl ml-8 flex flex-row">
              Step 2:
              <a className="pl-1 w-[40%]">
                Fill in your information in the table provided.
              </a>
            </p>
            <p className="text-[#6D6D6D] text-xl ml-8 flex flex-row">
              Step 3: <a className="pl-1 w-[40%]">Pay with credit card</a>
            </p>
            <p className="text-[#6D6D6D] text-xl ml-8 flex flex-row">
              Step 4:<a className="pl-1 w-[40%]">Receive email</a>
            </p>
            <p className="text-[#6D6D6D] text-xl ml-8 flex flex-row">
              Step 5:<a className="pl-1 w-[40%]">Give the e-service to dan</a>
            </p>
          </div>
        </div>
        <div
          id="review"
          className="bg-transparent py-16  text-center relative font-poppins"
        >
          <h2 className="text-5xl font-semibold text-[#0F2C59]">
            {averageRating.toFixed(1)}/5.0
          </h2>
          <div className="text-red-500 text-3xl my-4">
            {"❤️".repeat(averageRating) +
              "💔".repeat(5 - Math.floor(averageRating))}
          </div>
          <p className="text-[#0F2C59] mb-20 font-light text-4xl">
            Heartfelt reviews from our customers.
          </p>
          <div className="relative w-full h-auto">
            <Swiper
              modules={[FreeMode]}
              spaceBetween={40}
              slidesPerView={4}
              freeMode={true}
              style={{ padding: "0 120px" }}
              className="w-full h-full"
            >
              {reviews.map((item, index) => (
                <SwiperSlide key={index} className="h-auto pt-10">
                  <div className="relative bg-white border-8 border-[#0F2C59] border-opacity-65 py-3 rounded-xl flex flex-col items-center min-w-[250px] overflow-visible h-full">
                    <div
                      className="absolute -top-12 w-20 h-20 bg-[#0F2C59] rounded-full z-20 "
                      style={{
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                      }}
                    />
                    <h3 className="text-base font-normal text-[#0F2C59] mt-4 font-koulen ">
                      {item.name}
                    </h3>
                    <div className="text-red-500 -translate-y-1">
                      {"❤️".repeat(item.rating) + "💔".repeat(5 - item.rating)}
                    </div>
                    <p className="text-[#0F2C59] px-2 my-2 text-xs font-medium leading-none tracking-tight">
                      "{item.review}"
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div
          id="strength"
          className="relative py-16 px-6 text-center overflow-hidden my-40"
        >
          <div
            className="absolute inset-0 z-20"
            style={{
              background:
                "linear-gradient(to right, #F7F7F7 0%, #F7F7F700 6%, #F7F7F700 94%, #F7F7F7 100%)",
            }}
          />
          <h2 className="absolute text-5xl font-poppins inset-0 font-bold text-[#0F2C59] z-20">
            “Strength”
          </h2>
          <div className="absolute inset-0 flex flex-col items-center  opacity-25 text-[#0f2d59] font-black text-[210px] tracking-widest font-inknut leading-none z-10">
            <span className="relative top-0 left-[4%]">STRENGTH</span>
            <span className="relative -left-[30%]">STRENGTH</span>
            <span className="relative left-[15%]">STRENGTH</span>
          </div>
          <div className="grid grid-rows-2 gap-6 max-w-6xl mx-auto my-16">
            <div className="flex flex-row justify-center items-center gap-6">
              {strengths.slice(0, 3).map((item, index) => (
                <div
                  key={index}
                  className="border-8 font-poppins border-[#0F2C59] py-3 px-2 rounded-3xl shadow-lg bg-white bg-opacity-75 flex flex-col items-center w-full h-full"
                >
                  <img src={item.icon} className="text-4xl" />
                  <h3 className="text-lg font-bold mt-2 text-black">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-none tracking-normal font-normal mt-1 text-[#6D6D6D] h-full flex items-center ">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-3 gap-6 justify-center ">
              {strengths.slice(3).map((item, index) => (
                <div
                  key={index}
                  className="border-8 font-poppins border-[#0F2C59] py-3 px-2 rounded-3xl shadow-lg bg-white bg-opacity-75 flex flex-col items-center h-full relative left-[50%] translate-x-3"
                >
                  <img src={item.icon} className="text-4xl" />
                  <h3 className="text-lg font-bold mt-2 text-black">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-none tracking-normal font-normal mt-1 text-[#6D6D6D] h-full flex items-center ">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col h-auto">
        <div className="flex justify-center font-poppins text-5xl font-bold text-[#0F2C59]">
          Payment Channels
        </div>
        <div className="relative w-full h-auto mb-20 ">
          <Swiper
            modules={[FreeMode]}
            spaceBetween={20}
            slidesPerView={6.5}
            freeMode={true}
            // style={{ paddingRight: "0 120px" }}
            className="relative w-full h-full z-0"
            loop
          >
            {[
              "/visapay.png",
              "/googlepay.png",
              "/mastercard.png",
              "/touchngo.png",
              "/grabpay.png",
              "/americanex.png",
              "/shopeepay.png",
              "/fpx.png",
            ].map((src, index) => (
              <SwiperSlide key={index} className="z-10">
                <div className="flex justify-center items-center h-[6vw] my-10">
                  <img
                    src={src}
                    className="h-full w-auto object-contain"
                    alt=""
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className="absolute inset-0 z-20 w-full h-full pointer-events-none "
            style={{
              backgroundImage:
                "linear-gradient(to right, #F7F7F7 0%, #F7F7F700 6%, #F7F7F700 94%, #F7F7F7 100%)",
            }}
          />
        </div>
      </div>

      <div className="flex">
        <div className="grid grid-cols-[70%_30%] gap-10 pl-4 pr-14 object-contain">
          <div className="basis-[70%] grid grid-rows-2 gap-4">
            <div className="grid grid-cols-[67.5%_32.5%] gap-4">
              <img
                src="/bot1.png"
                className="w-full h-full object-cover rounded-lg"
                alt="img1"
              />
              <img
                src="/bot2.png"
                className="w-full h-full object-cover rounded-lg"
                alt="img2"
              />
            </div>
            <div className="grid grid-cols-[44.25%_55.75%] gap-4">
              <img
                src="/bot3.png"
                className="w-full h-full object-cover rounded-lg"
                alt="img3"
              />
              <img
                src="/bot4.png"
                className="w-full h-full object-cover rounded-lg"
                alt="img4"
              />
            </div>
          </div>
          <div className="basis-[30%]">
            <img
              src="/bot5.png"
              className="w-full h-full object-cover rounded-lg"
              alt="img5"
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center space-y-10 font-poppins mt-32">
        <div className="text-center p-6 w-full">
          <h2 className="text-2xl font-normal text-gray-900 leading-[133%]">
            Have any questions or need further information,
            <br />
            kindly click this button.
          </h2>
          <a
            href="https://wa.me/message/SM6EHEQA4CUSP1"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center bg-[#45C655] text-white text-2xl font-medium px-10 py-2 rounded-xl shadow-md hover:bg-green-600 transition"
            style={{
              boxShadow:
                "inset -2px -2px 4px rgba(0, 0, 0, 0.7),inset 2px 2px 4px rgba(255, 255, 255, 0.7)",
              filter: "drop-shadow(0px 4px 6.9px rgba(0, 0, 0, 0.25))",
            }}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              className="w-8 h-8 mr-2"
            />
            Contact Us
          </a>
        </div>
      </div>
      <img
        src="/lastbanner.png"
        className="flex w-[60vw] h-auto transform translate-x-[20vw] mb-10"
        alt=""
      />
      <Footer />
      {isPopupOpen && (
        <div className="fixed inset-0 w-screen h-screen bg-black bg-opacity-50 z-[9999]">
          <div className="flex justify-center items-center w-full h-full">
            <div className="relative w-[80vw] h-auto p-12 bg-white rounded-3xl font-poppins">
              <button
                onClick={handleClosePopup}
                className="absolute top-8 right-8 text-2xl "
              >
                <RxCross2 className="text-[#C5C5C5] w-8 h-8" />
              </button>
              <div className="flex flex-col items-center ">
                <img
                  src="/gold_bg.png"
                  alt=""
                  className="rounded-full w-[10vw] h-[10vw] object-cover "
                />
                <img
                  src="/gold.png"
                  alt=""
                  className="absolute w-[15vw] translate-x-1 -translate-y-3"
                />
                <div className="text-3xl px-16 font-normal text-black mt-4 text-center leading-[124%]">
                  Would you like to enhance your car’s coverage? Upgrade to the
                  <span className="text-[#E2BD4B]"> Gold Package</span> to
                  include coverage for your own car and enjoy greater peace of
                  mind!
                </div>
                <NavLink
                  className="font-bold text-white rounded-full w-auto mt-6"
                  style={{
                    backgroundImage: "url(/gold_bg.png)",
                    backgroundSize: "cover",
                  }}
                  to="/info?pkg=gold"
                >
                  <div className="w-full h-full px-7 py-3 text-xl bg-[#9D7B14] bg-opacity-50 rounded-full">
                    Upgrade Now
                  </div>
                </NavLink>
                <NavLink
                  className="text-xl font-normal tracking-widest underline mt-4"
                  to={`/info?pkg=${pkg}`}
                >
                  Keep Current Plan
                </NavLink>
              </div>

              <div />
            </div>
          </div>
        </div>
      )}
      {popupLogin && (
        <div className="fixed inset-0 w-screen h-auto min-h-screen bg-black bg-opacity-50 z-[9999]">
          <div className="flex justify-center items-center w-full h-full">
            <form
              className="relative w-[35vw] h-auto p-12 bg-white rounded-3xl font-poppins"
              onSubmit={handleLogin}
            >
              <div className="text-4xl text-center mb-8">Login</div>
              <div className="text-xl font-light">Email</div>
              <input
                type="email"
                className="w-full bg-[#EDEDED] text-lg font-light px-4 py-2 rounded-full my-2"
              />
              <div className="text-xl font-light">Password</div>
              <input
                type="password"
                className="w-full bg-[#EDEDED] text-lg font-light px-4 py-2 rounded-full my-2"
              />
              <div className="flex justify-between">
                <div className="text-base font-light my-2 items-center justify-center">
                  <input
                    type="checkbox"
                    name="personal"
                    checked={isRemember}
                    onChange={handleRememberChange}
                    className="mx-2 placeholder-[#808080]"
                  />
                  Remember me
                </div>
                <button
                  onClick={openPopupForgot}
                  className="text-base font-light my-2 hover:underline"
                >
                  Forgot Password?
                </button>
              </div>
              <button
                type="submit"
                className="w-full bg-[#0F2C59] text-base font-normal py-3 rounded-full my-2 text-white"
              >
                Log in
              </button>
              <div className="flex items-center my-2">
                <div className="flex-grow border-t border-black" />
                <span className="text-base font-light mx-2 text-black">
                  If you don't have an account
                </span>
                <div className="flex-grow border-t border-black" />
              </div>
              <div className="grid grid-cols-2 gap-2 mt-4">
                <button
                  onClick={openPopupSignup}
                  className="font-light text-base bg-[#EDEDED] rounded-full py-3"
                >
                  Sign up
                </button>
                <button
                  onClick={closePopupLogin}
                  className="font-light text-base bg-[#EDEDED] rounded-full py-3"
                >
                  Use as Guest
                </button>
              </div>

              <div />
            </form>
          </div>
        </div>
      )}
      {popupForgot && (
        <div className="fixed inset-0 w-screen h-auto min-h-screen bg-black bg-opacity-50 z-[9999]">
          <div className="flex justify-center items-center w-full h-full">
            <div className="relative w-[40vw] h-auto py-10 px-24 bg-white rounded-3xl font-poppins ">
              <div className="flex items-center justify-center my-2">
                <img src="/lock.png" alt="" className="w-[55%] h-[55%]" />
              </div>
              <div className="text-2xl text-center">Forgot your password?</div>
              <div className="text-sm font-light text-[#9A9A9A] px-7 text-center mb-8">
                Please enter your email to receive a link to reset your password
              </div>
              <input
                type="email"
                placeholder="Enter Your Email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                className="w-full bg-[#EDEDED] text-base font-light px-4 py-3 rounded-full my-2 placeholder:text-center"
              />
              <button
                onClick={closePopupForgot}
                className="w-full bg-[#0F2C59] text-base font-normal py-3 rounded-full my-2 text-[#D9D9D9]"
              >
                Send Email
              </button>
              <div className="flex justify-center my-2">
                <button
                  onClick={openPopupLogin}
                  className="flex font-light text-sm  text-[#9A9A9A]"
                >
                  Back to Login
                </button>
              </div>

              <div />
            </div>
          </div>
        </div>
      )}
      {popupSignup && (
        <div className="fixed inset-0 w-screen h-auto min-h-screen bg-black bg-opacity-50 z-[9999]">
          <div className="flex justify-center items-center w-full h-auto">
            <form
              className="relative w-[35vw] h-auto px-14 py-12 bg-white rounded-[2rem] font-poppins my-[5vh]"
              onSubmit={handleSignup}
            >
              <div className="text-[40px] text-center mb-0">Sign Up</div>
              <div className="text-xl font-light">Email</div>
              <input
                type="email"
                className="w-full bg-[#EDEDED] text-xl font-light px-4 py-2 rounded-full my-3"
              />
              <div className="text-xl font-light">Password</div>
              <input
                type="password"
                className="w-full bg-[#EDEDED] text-lg font-light px-4 py-2 rounded-full my-3"
              />
              <div className="text-xl font-light">Confirm Password</div>
              <input
                type="password"
                className="w-full bg-[#EDEDED] text-lg font-light px-4 py-2 rounded-full my-3"
              />
              <button
                type="submit"
                className="w-full bg-[#0F2C59] text-xl font-normal py-2 rounded-full my-4 text-white"
              >
                Sign Up
              </button>
              {/* <div className="flex items-center my-2">
                <div className="flex-grow border-t border-black" />
                <span className="text-base font-light mx-2 text-black">Or</span>
                <div className="flex-grow border-t border-black" />
              </div>

              <button
                onClick={closePopupSignup}
                className="w-full font-normal h-10 text-xl bg-[#1877F2] rounded-full py-2 my-2 text-white leading-[109%]"
              >
                <img
                  src="/f.png"
                  alt=""
                  className="absolute h-8 -translate-y-1 translate-x-6"
                />
                Sign up with Facebook
              </button>
              <button
                onClick={closePopupSignup}
                className="w-full font-normal h-10 text-xl bg-[#B62323] rounded-full py-2 my-2 text-white leading-[109%] "
              >
                <img
                  src="/g.png"
                  alt=""
                  className="absolute h-8 -translate-y-1 translate-x-6"
                />
                Sign up with Google
              </button> */}
              <div className="flex justify-center my-1">
                <button
                  onClick={openPopupLogin}
                  className="flex font-light text-sm  text-[#9A9A9A]"
                >
                  Back to Login
                </button>
              </div>

              <div />
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
